import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFound from '../views/Page/Exception/404'

import { localization } from '../plugins/localization'

Vue.use(VueRouter)

const HomeLayout = () => import(
  /* webpackPrefetch: 1, webpackChunkName: "page/layout/layout-home" */ '../views/Layouts/HomeLayout.vue'
)

const MainLayout = () => import(
  /* webpackPrefetch: 1, webpackChunkName: "page/layout/layout-main" */ '../views/Layouts/MainLayout.vue'
)

const routes = [
  {
    path: '',
    name: 'Home',
    component: () => import(/* webpackChunkName: "page/home" */ '../views/Page/Home/Home.vue'),
    meta: {
      layout: HomeLayout
    }
  },
  {
    path: ':page(main-economic-indicator|international-ratings)',
    name: 'Page.1',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(
      /* webpackChunkName: "page/main/nested/economicIndicator/main-economicIndicator" */
      '@/views/Page/Main/Main.vue'),
    meta: {
      layout: MainLayout
    },
    children: [
      {
        path: 'step/:stepId',
        name: 'Page.1.Step.1',
        component: () => import(
          /* webpackChunkName: "page/main/nested/economicIndicator/nested/dynamic-page" */
          '@/views/Page/Main/nested/DynamicPage.vue'
        )
      }    
    ]
  },
  {
    path: 'iframe',
    name: 'iframe',
    component: () => import(/* webpackChunkName: "page/Highchart" */ '@/components/Main/EconomicIndicator/Highchart'),
    meta: {
      layout: HomeLayout
    }
  },
  {
    path: '404',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { selector: to.hash }
    } else if (from.params.stepId || to.params.stepId) {
      return { x: 0, y: 0 }
    }
    return {}
  },
  routes: [{
    path: '/:locale(ka|en)?',
    component: {
      render: h => h('router-view')
    },
    beforeEnter (to, from, next) {
      if (to.fullPath.match(/.+\/$/)) {
        router.replace({ path: to.fullPath.replace(/^(.+?)\/*?$/, '$1') }).catch(() => {})
        next()
        return
      }
      localization.loadLocaleMessagesAsync(to.params.locale ?? 'ka')
      next()
    },
    children: routes
  }]
})

export default router
